// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"752f2a49","455":"2385546c","977":"a0abad27"}[chunkId] + ".chunk.js";
};